import { FieldsFactory } from '../../../Factory/FieldsFactory';
import { AlgorithmHeatmapInstrumentGroup } from './AlgorithmHeatmapInstrumentGroup';
export class AlgorithmHeatmapDelayDataGroup extends AlgorithmHeatmapInstrumentGroup {
    constructor(pfixFieldSet) {
        super(FieldsFactory.ALGORITHM_HEATMAP_DELAY_DATA_GROUP, pfixFieldSet);
    }
}
